import { useCallback, useMemo } from 'react'

import { useModalStore } from '@features/modal'


import ModalCategories, { ModalCategoriesProps } from '../ui'

export type CategoriesModalOptions = {
  hideIconClose?: boolean
  disabledScroll?: boolean
  topOffset?: number
  backdropTopOffset?: number
  classes?: {
    modal?: string
    body?: string
    content?: string
  }
}
export type OpenCategoriesModalProps = {
  props?: ModalCategoriesProps
  options?: CategoriesModalOptions
}

export const useCategoriesModal = () => {
  const { modals, openModal, closeModal } = useModalStore()

  const categoriesModal = useMemo(() => modals.get('categories'), [ modals ])

  const isOpen = useMemo(() => categoriesModal?.isOpen === true, [ categoriesModal ])

  const openCategoriesModal = useCallback(({ props = {}, options = {} }: OpenCategoriesModalProps = {}) => {
    if (isOpen) {
      closeModal('categories')
    }
    else {
      openModal('categories', <ModalCategories {...props} />, options)
    }
  }, [ isOpen, closeModal, openModal ])

  const closeCategoriesModal = useCallback(() => {
    closeModal('categories')
  }, [ closeModal ])

  return {
    modal: categoriesModal,
    isOpen,
    openModal: openCategoriesModal,
    closeModal: closeCategoriesModal,
  }
}